<template>
  <v-row no-gutters align-content="start" class="cirrus-comparison-wrapper">
    <v-col cols="12">
      <cirrus-comparison-toolbar :name="name"
        :context="context"
        :exams="exams"
        :groups="groups" />
    </v-col>
    <v-col cols="12" class="cirrus-state-controls">
      <v-row no-gutters align="center" justify="center">
        <v-flex shrink>
          <v-btn
            text
            class="modal-cta"
            :class="[{active: showOverlay}, colorClass]"
            @click="toggleOverlay">Overlay</v-btn>
        </v-flex>
        <v-flex shrink>
          <reset-slider
            :value="overlayOpacity"
            :color="colorHex"
            :min="0"
            :max="1"
            :step="0.05"
            :defaultValue="1"
            @input="updateOpacity"
            name="Overlay Intensity"
            class="overlay-slider"/>
        </v-flex>
        <v-flex shrink>
          <v-btn text
            class="modal-cta"
            :class="[{active: showETDRS}, colorClass]"
            @click="toggleETDRS">ETDRS</v-btn>
        </v-flex>
        <v-flex shrink>
          <v-btn
            text
            class="modal-cta"
            :class="[{active: hasColorPalette}, colorClass]"
            @click="toggleColor">Color</v-btn>
        </v-flex>
        <v-flex shrink>
          <v-btn text
            class="modal-cta"
            :class="[{active: isInverted}, colorClass]"
            @click="invertColor">Invert</v-btn>
        </v-flex>
        <v-flex shrink>
          <v-btn
            text
            class="modal-cta"
            :class="[{active: showSegmentation}, colorClass]"
            @click="toggleSegmentation">Segmentation</v-btn>
        </v-flex>
      </v-row>
    </v-col>
    <cirrus-comparison-view-optic-disc-body-content
      v-if="this.isOpticDisc" 
      :name="name"
      :context="context"
      :exams="exams"
      :groups="groups"/>
    <cirrus-comparison-view-body-content
      v-else 
      :name="name"
      :context="context"
      :exams="exams"
      :groups="groups"/>
  </v-row>
</template>

<script>
import resetSlider from "../../controls/ResetSlider";
import cirrusComparisonToolbar from "./CirrusComparisonToolbar";
import cirrusComparisonViewBodyContent from "./CirrusComparisonViewBodyContent";
import cirrusComparisonViewOpticDiscBodyContent from "./CirrusComparisonViewOpticDiscBodyContent";
import responsiveCanvases from "../../mixins/ResponsiveCanvases";
import { SeriesTypes } from "../../../config/config";
export default {
  name: "cirrusComparisonView",
  components: {
    cirrusComparisonToolbar,
    cirrusComparisonViewBodyContent,
    cirrusComparisonViewOpticDiscBodyContent,
    resetSlider,
  },
  mixins: [responsiveCanvases],
  props: {
    name: String,
    context: Object,
    exams: Array,
    groups: Array
  },
  methods: {
    toggleColor() {
      this.$store.dispatch("toggleColorCompare", this.name);
    },
    invertColor() {
      this.$store.dispatch("toggleInvertedCompare", this.name);
    },
    toggleSegmentation() {
      this.$store.commit("toggleSegmentationCompare", this.name);
    },
    toggleOverlay() {
      this.$store.commit("toggleOverlayCompare", this.name);
    },
    updateOpacity(opacity) {
      this.$store.commit("updateOverlayOpacityCompare", {
        view: this.name,
        opacity
      });
    },
    toggleETDRS() {
      this.$store.commit("toggleETDRSCompare", this.name);
    }
  },
  computed: {
    hasSegmentation() {
      return this.sliceInfo && this.sliceInfo.sliceHasSegmentation;
    },
    showSegmentation() {
      return this.context && this.context.showSegmentation;
    },
    showOverlay() {
      return this.context && this.context.showOverlay;
    },
    overlayOpacity() {
      return this.context && this.context.overlayOpacity;
    },
    showETDRS() {
      return this.context && this.context.showETDRS;
    },
    colorSettings() {
      return this.context && this.context.octColorSettings;
    },
    hasColorPalette() {
      return this.colorSettings && !!this.colorSettings.colorPalette;
    },
    isInverted() {
      return this.colorSettings && this.colorSettings.isInverted;
    },
    isOpticDisc() {
      return this.context && this.context.seriesType == SeriesTypes.OpticDisc;
    }
  }
};
</script>